module.exports = __webpack_public_path__ + "img/2-white.8fdbb91f.svg";